"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Agent {
    constructor(id) {
        this._id = id;
    }
    get id() {
        return this._id;
    }
}
exports.default = Agent;
//# sourceMappingURL=Agent.js.map